// extracted by mini-css-extract-plugin
export default {"progress-message":"_0TLWa90m+4","progressMessage":"_0TLWa90m+4"};